<div class="moneyline-wrapper">
  @for (period of linesByPeriod; track period) {
    <div class="period" [ngClass]="period.period">
      <div class="header">{{ period.period }}</div>
      <div class="div-table">
        <div class="div-table-row">
          <div class="div-table-col" align="center">&nbsp;</div>
          @for (line of period.lines; track line) {
            <div class="div-table-col logo" align="center">
              <img src="https://www.pinnacle.com/img/icons/pwa-192x192.png" />
            </div>
          }
        </div>
        <div class="div-table-row">
          <div class="div-table-col" align="center">H:</div>
          @for (line of period.lines; track line) {
            <div class="div-table-col" align="center">
              <app-form-field-odds
                [data]="line.home"
                [fieldConfig]="fieldConfig"
                [editMode]="editMode"></app-form-field-odds>
            </div>
          }
          <div class="div-table-col" align="center">Bet</div>
        </div>
        <div class="div-table-row">
          <div class="div-table-col" align="center">D:</div>
          @for (line of period.lines; track line) {
            <div class="div-table-col" align="center">
              <app-form-field-odds
                [data]="line.draw"
                [fieldConfig]="fieldConfig"
                [editMode]="editMode"></app-form-field-odds>
            </div>
          }
          <div class="div-table-col" align="center">Bet</div>
        </div>
        <div class="div-table-row">
          <div class="div-table-col" align="center">A:</div>
          @for (line of period.lines; track line) {
            <div class="div-table-col" align="center">
              <app-form-field-odds
                [data]="line.away"
                [fieldConfig]="fieldConfig"
                [editMode]="editMode"></app-form-field-odds>
            </div>
          }
          <div class="div-table-col" align="center">Bet</div>
        </div>
      </div>
    </div>
  }
</div>
